import styled from "styled-components";

import * as mixins from "./mixins";
import * as animations from "./animations";

export const StyledContainer = styled.div`
  display: flex;
  user-select: none;

  ${(props) => (props.between ? mixins.between : "")}
`;

export const Savings = styled.h2`
  margin: 0;
  color: white;
  font-weight: normal;
  text-align: center;
  font-size: 18px;
  background: #13bfbf;
  flex: 1;
  padding: 5em 0;
  border-top-left-radius: 140px;
  border-bottom-right-radius: 140px;
`;

export const SavingsValue = styled.span`
  font-size: 52px;
  display: block;
`;

export const DecorationMiddle = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 620px) {
    display: none;
  }
`;

export const DecorationMiddleTop = styled.div`
  width: 280px;
  height: 404px;
  background: #00a5a5;
  margin-bottom: 1em;
  border-bottom-right-radius: 140px;
  display: flex;
  align-items: flex-end;
  animation: ${animations.middleTop} 0.8s 0.4s backwards;
`;

export const DecorationMiddleBottom = styled.div`
  background: #a4f9f2;
  width: 177px;
  height: 177px;
  border-bottom-right-radius: 88.5px;
  transform-origin: top left;
  animation: ${animations.middleBottom} 0.4s 0.8s backwards;
`;

export const DecorationMiddleBottomInner = styled.div`
  width: 100%;
  height: 100%;
  background: #85dfd8;
  border-top-left-radius: 100%;
  border-bottom-right-radius: 88.5px;
`;

export const DecorationRight = styled.div`
  width: 107px;
  height: 245px;
  background: #286dd6;
  margin-left: 1em;
  border-bottom-left-radius: 161px;
  animation: ${animations.right} 0.4s 1s backwards;
  ${(props) => (props.restrained ? mixins.restrained : "")}
`;

export const DecorationRightTop = styled.div`
  height: 135px;
  width: 100%;
  background: #0b53c1;
  border-bottom-right-radius: 133px;
`;

export const Dude = styled.img`
  align-self: flex-end;
  margin-right: 1em;
  animation: ${animations.dude} 0.8s 0.4s backwards;
  ${(props) => (props.small ? mixins.small : "")}
`;
